import _ from 'underscore';

/**
 * Tcp server codes
 */

const Codes: { [key: string]: any } = {};

Codes.Types = {
  CP_LOGIN: 127, //When sending
  CP_MESSAGE: 1,
  CP_TABLE_JOIN: 2,
  CP_TABLE_SERVE: 3,
  CP_PLAY: 4,
  CP_QUIT: 5,
  CP_PING: 6,
  CP_LAG: 7,
  CP_FINGER: 9,
  CP_SERVICE: 10,
  CP_INVITE: 12,
  CP_MOVE: 13,
  CP_ALIVE: 14,
  CP_TABLE_OP: 15,
  CP_GM_COMMAND: 16,
  CP_SCOMMAND: 18,
  CP_SET_LANGUAGE: 19,
  CP_GET_PROGRESS: 20,
  CP_CLIENT_VERSION: 21,

  SP_YOU_ARE: 127, // When receiving
  SP_ERROR: 1,
  SP_JOIN: 2, // New player
  SP_LEAVE: 3,
  SP_TABLE_OPT: 4,
  SP_TABLE_PLAYER: 5, // Player joined to table
  SP_MESSAGE: 6,
  SP_GAME: 7,
  SP_MOVE: 8,
  SP_STAT: 9,
  SP_LAG: 10,
  SP_TABLE_LEAVE: 11,
  SP_WIN: 15,
  SP_FINGER: 21,
  SP_PROTOCOL_VERSION: 22,
  SP_INVITE: 23,
  SP_GAME_PROGRESS: 24,
  SP_TABLE_OWN: 25,
  SP_PLAYER_SWAP: 26,
  SP_ALIVE: 27,
  SP_COMMAND: 28,
  SP_DEAL: 29,
  SP_SCORE: 30,
  SP_MONEY: 31,
  SP_AVATAR: 32,
  SP_SCOMMAND: 34,
  SP_WIN2: 35,
  SP_SERVER_VERSION: 36,
  names: {
    sending: {},
    receiving: {},
  },
};

// Codes.Types.names = {
//   sending  : {},
//   receiving: {}
// };

Object.keys(Codes.Types).forEach(function (key) {
  let t = '';
  if (key.match(/sp/i)) t = 'receiving';
  if (key.match(/cp/i)) t = 'sending';
  const v = Codes.Types[key];
  if (!t) return;
  Codes.Types.names[t][v] = key;
});

Codes.Commands = {
  MUTE: 0, // MUTE PLAYER
  UNMUTE: 1, // UNMUTE PLAYER
  IGNORE: 2, // IGNORE PLAYER
  UNIGNORE: 3, // UNIGNORE PLAYER
  HELP: 4, // UNIGNORE PLAYER
  POSTPONE: 7, // LOST CONNECTION FROM THE TABLE
  R_ENABLE: 8, // LOST CONNECTION - ENABLE BUTTONS
  R_STOP: 9, // Оппонент восстановил соединение
  R_WAIT: 10, // COMMAND FOR CLIENT TO SHOW DIALOG WITH BUTTONS
  PM_REQ: 11, // COMMAND FOR CLIENT TO SHOW DIALOG WITH BUTTONS
  PM_WAIT: 12, // COMMAND FOR CLIENT TO ADD 1 MINUTE TO TIMER
  PM_URGE: 13, // COMMAND FOR CLIENT TO URGE HIM TO MOVE
  AVATAR: 14, // COMMAND FOR CLIENT TO SET NEW AVATAR
  COLORED: 15, // COLORED IN CHAT
  UNCOLORED: 16, // UNCOLORED IN CHAT
  PM_INFO: 17, // COMMAND FOR CLIENT INFORM, THAT OPPONENT URGED TO MOVE
  ALERT: 18, // COMMAND FOR CLIENT TO CALL HIM
  RECONNECTION_TIME: 21, //COMMAND TO PASS CLIENT RECONNECTION TIME
  PING_TIM: 22, // COMMAND TO PASS CLIENT PING TIME
  // START_BUTTON_VISIBLE: 25,  COMMAND TO MAKE CLIENT SHOW START BUTTON
  START_CONFETTI: 25,
};

Codes.Commands.names = _.invert(Codes.Commands);

Codes.PlayerFlags = {
  MUTE: 1 << 0,
  ADM: 1 << 1,
  TESTER: 1 << 2,
  BADGUY: 1 << 3,
  TD: 1 << 4,
  RESERVED2: 1 << 5,
  VIP: 1 << 6,
  MONEY: 1 << 7,
  PROMO: 1 << 10,
  LIMIT: 1 << 13, //# 8192  Limit Manual
  LIMIT10: 1 << 14, //# 16384 Limit $10
  LIMIT25: 1 << 15, //# 32768 Limit $25
  LIMIT50: (1 << 14) | (1 << 15), //     Limit 50
  CHEATER: 1 << 16,
  KID: 1 << 19,
  CLUB: 1 << 13,
  ANDRDEBUG: 1 << 26,
  BOT: 1 << 27,
  PHANTOM: 1 << 28,
};

Codes.TableFlags = {
  /** no takeback - for sign */
  NOTAKEB: 1 << 0,
  /** loser deals for gin // Rotated for Dominoes */
  LOSDEAL: 1 << 1,
  /** have spinner for domino */
  SPIN: 1 << 2,
  /** forced double on 1st move for domino */
  DBL1: 1 << 3,
  /** 9-bone hand */
  DOM9: 1 << 4,
  /** CANASTA Top cand can be added to canasta */
  TOPMLD: 1 << 5,
  /** CANASTA Dicard pile is always frozen */
  FROZ: 1 << 6,
  /** reserved */
  FROZ2: 1 << 7,
  /** CANASTA Red 3 freez pile or CRIBBAGE 2/3 game match*/
  RED3: 1 << 8,
  TWOGAMEMATCH: 1 << 8,
  /** CANASTA wild canasta */
  WILD: 1 << 9,
  /** POOL - banking */
  BANK: 1 << 10,
  /** CRIBBAGE - manual score */
  MANUAL: 1 << 11,
  /** CRIBBAGE - don't show discard */
  DISCARD: 1 << 12,
  /** SPADES - Sundbag option */
  SANDBAG: 1 << 13,
};

Codes.TableFlags.names = _.invert(Codes.TableFlags);

Codes.PlayerFilter = {
  NONE: 0,
  MUTE: 1,
  IGNORE: 2,
};

Codes.PlayerFilter.names = _.invert(Codes.PlayerFilter);

Codes.JoinMode = {
  LEAVE_S: -3,
  LEAVE: -2,
  PLAY: 0,
  WATCH: 1,
  INVITED: 2,
  WPLAY: 3,
  RE_PLAY: 4,
};

Codes.JoinMode.names = _.invert(Codes.JoinMode);

Codes.ErrorTypes = {
  LOGIN_OK: '0-0', //no error
  LOGIN_READY: '0-1', //no error
  LOGIN_TWICE: '0-2',
  LOGIN_BADPASS: '0-3',
  LOGIN_EXIST: '0-4',
  LOGIN_NONEXIST: '0-5',
  LOGIN_BANNED: '0-6',
  LOGIN_SERVER_FULL: '0-7',
  LOGIN_PLEASE: '0-8',
  LOGIN_SERVER_DOWN: '0-9',
  LOGIN_SERVER_SHUTDOWN_PROGRESS: '0-10',
  LOGIN_MONEY: '0-11',
  LOGIN_WRONG_PROTOCOL: '0-12',
  LOGIN_ENTER_ROOM: '0-13',
  LOGIN_RESERVED2: '0-14',
  LOGIN_NOT_PASSED: '0-15',
  LOGIN_CHECKING: '0-16',
  LOGIN_CONNECTED: '0-17',
  LOGIN_HOST_NOTFOUND: '0-18',
  LOGIN_CHECKING_PASSWORD: '0-19',
  LOGIN_RECONNECT: '0-20',
  LOGIN_RC_FORCE: '0-21',
  TABLE_OK: '1-0',
  TABLE_ALREADY_ON: '1-1',
  TABLE_NOT_ON: '1-2', // null ErrorTypes
  TABLE_UNINVITED: '1-3',
  TABLE_REOPTION: '1-4',
  TABLE_NOT_CREATOR: '1-5',
  TABLE_FULL: '1-6',
  TABLE_SERVER_FULL: '1-7',
  TABLE_NOT_PLAYER: '1-8',
  TABLE_NONEXIST: '1-9',
  TABLE_NO_INVITEE: '1-10',
  TABLE_INVITE_DECL: '1-11',
  TABLE_OPPONENT_LEFT: '1-12',
  TABLE_ASK_CLOSE: '1-13',
  TABLE_WAIT_OPPONENT: '1-14',
  TABLE_INVITATION_SENT: '1-15',
  TABLE_U_A_INVITED: '1-16',
  TABLE_TOO_MANY: '1-17',
  TABLE_YOU_LEFT: '1-18',
  TABLE_JOINED: '1-19',
  TABLE_BANNED: '1-20',
  PLAY_OK: '3-0',
  PLAY_NO_START: '3-1',
  PLAY_NO_TURN: '3-2',
  PLAY_ILLEGAL: '3-3',
  PLAY_WAIT_START: '3-4',
  PLAY_WAIT_CONFIRM: '3-11',
  PLAY_REFUSED: '3-12',
  PLAY_VIOLATE: '3-13', // null error
  PLAY_RESERVED1: '3-14',
  PLAY_REVIEW: '3-20',
  command_ok: '4-0',
  unknown_command: '4-1',
  bad_command_format: '4-2',
  no_such_player: '4-4',
  NOT_IMPLEMENTED: '6-0',
  TOO_MANY_OFFERS: '6-1',
  VARI_TO_ALL_FREQUENT: '6-2',
  VARI_PLEASE_WAIT: '6-3',
  VARI_INCORRECT_TIME: '6-4',
  VARI_HELP_NOT_FOUND: '6-5',
  VARI_NOT_VIP: '6-6',
  VARI_VIPCASH: '6-7',
  VARI_SEND_DIRECT: '6-8',
  VARI_RC_OPPCONN: '6-9',
  VARI_TPM_EXP: '6-10',
  VARI_FOR_VIP_ONLY: '6-11',
  VARI_1_MINUTE: '6-12',
  TOUR_ENTER: '7-0',
  TOUR_CANT_START: '7-1',
  TOUR_NO_ACCOUNT: '7-2',
  TOUR_CANT_WATCH: '7-3',
  TOUR_DIF_OPPONENT: '7-4',
};

Codes.ErrorTypes.names = _.invert(Codes.ErrorTypes);

Codes.GameActions = {
  START: 0,
  END: 1,
  OFFER_DRAW: 2 /** to force client to sh ow dialog */,
  OFFER_TAKEBACK: 3 /** to force client to show dialog */,
  DRAW: 4 /** final clause, result DRAW */,
  RESIGN: 5 /** final clause, result RESIGN */,
  TAKEBACK: 6 /** final clause, result TAKEBACK */,
  START_PRESSED: 7 /** One player pressed "Start" buttons to start to play */,
  OFFER_ABORT: 8 /** to force client to show dialog */,
  ABORT: 9 /** to force client to show dialog */,
  OFFER_RESTART: 10 /** to force client to show dialog */,
  RESTART: 11 /** to force client to show dialog */,
  REFUSED: 12 /** opponent refused a request */,
  BREAK: 13 /** if somebody went out during a game */,
  CHECK_TIME: 14 /** request to player to approve move limit finish */,
  KNOCK: 16 /** to make players to skip a move */,
  CONTINUE: 17 /** to make players to skip a move */,
  REPEAT: 18 /** error - repeat last move */,
  OFFER_RESCUR: 19 /** ask opponent's confirmation of resigning */,
  OFFER_RESDBL: 20 /** ask opponent's confirmation of resigning */,
  REVIEW: 21 /** game aborted by review */,
  TRNID: 22 /** pass a tourneyID */,
  SKIP: 50 /** to make players to skip a move */,
  DICE: 51,
  DICE_FIRST: 52,
  DOUBLE_OK: 53,
  CONFIRM: 54,
  GET_FIRST_MOVE: 61,
  MELD: 305,
  INIT: 400,
  SCORE: 401,
  NEXT: 402,
  BOGUS: 403,
};

Codes.GameActions.names = _.invert(Codes.GameActions);

Codes.GameCommands = {
  INIT_TABLE: 521,
  LOAD_DICE: 522,
  LOAD_HISTORY: 523,
  REPEAT_STATE: 524,
  SKIP: 50,
  DOUBLE_OK: 526,
  DOUBLE_NOK: 527,
  GET_DICE: 528,
  GET_FIRST_DICE: 529,
  SHOW_PRICE: 530 /** resign with the current score */,
  RESCUR: 531 /** resign with the doubled score */,
  RESDBL: 532,
  LOAD_STATE: 533,
  REPEAT_DICE: 534,
  DICE: 51,
  DICE_FIRST: 52,
  CONFIRM: 54,
  GET_FIRST_MOVE: 61,
  FISH: 601,
  MELD: 305,
  OPEN: 602,
};

Codes.GameCommands.names = _.invert(Codes.GameCommands);

Codes.ScoresTypes = {
  LAST: 1,
  FULL: 2,
  FULL_REV: 3,
};

Codes.ScoresTypes.names = _.invert(Codes.ScoresTypes);

Codes.MessageTypes = {
  ALL: -2, // Сообщения в общий чат
  TABLE: -3, // Сообщения на игровой стол
  INDIV: -4, // Индивидуальные сообщения
  COMMAND: -5, // Команды
  YOU: -6, // Эхо
  GOD: -7, // От администратора
  INFO: -8, // Информационные сообщения на игровой стол
};

Codes.MessageTypes.names = _.invert(Codes.MessageTypes);

Codes.InviteType = {
  ALL: 0,
  IND: 1,
  SIMILAR: 2,
  DECLINE: 4,
  NONE: 5,
};

Codes.InviteType.names = _.invert(Codes.InviteType);

Codes.WinAction = {
  WIN: 6,
  LOST: 14,
  DRAW_OK: 10,
  LEAVE: 20,
};

Codes.WinAction.names = _.invert(Codes.WinAction);

Codes.WinReason = {
  CHECK_TIME: 13,
  CHECK_TIME_DR: 26,
  LEAVE: 20,
  STALEMATE: 4,
  RESIGN: 1,
};

Codes.WinReason.names = _.invert(Codes.WinReason);

Codes.GameStringCommands = {
  OS: 1,
  SCORE: 2,
  COMMAND_CONFETTI: 25,
};

Codes.GameStringCommands.names = _.invert(Codes.GameStringCommands);

Codes.AvatarSize = {
  SMALL: 0,
  MEDIUM: 1,
  BIG: 2,
};

Codes.AvatarSize.names = _.invert(Codes.AvatarSize);

Codes.PlayCommand = {
  OK: 0,
  RESIGN: 1,
  DRAW: 2,
  TAKEBACK: 3,
  STALEMATE: 4,
  REPEAT: 5,
  WIN: 6,
  RESIGN_CUR: 7, //V29
  RESIGN_DBL: 8, //V29
  START: 9,
  DRAW_OK: 10,
  TAKEBACK_OK: 11,
  ACTION_REFUSED: 12,
  CHECK_TIME: 13,
  LOST: 14,
  ABORT: 15,
  ABORT_OK: 16,
  LEAVE_S: 17,
  RESTART: 18,
  RESTART_OK: 19,
  LEAVE: 20,
  REVIEW_ABORT: 21,
  KNOCK: 22,
  CONTINUE: 23,
  GET_DICE: 24,
  TAKEBACK_NOK: 25,
  CHECK_TIME_DR: 26,
  RESCUR_OK: 27, //V29
  RESDBL_OK: 28, //V29
  ABORT_PM: 29, //V31
  SKIP: 50,
};

Codes.PlayCommand.names = _.invert(Codes.PlayCommand);

Codes.MoneyMessageTypes = {
  WIN: 6,
  START: 9,
  ABORT: 15,
  OK: 0,
};

Codes.TableOpMode = {
  BAR: 7,
  ABORT_R: 8,
  WIN_R: 9,
  ABORT_PM: 10,
  WIN_PM: 11,
};

Codes.TableOpMode.names = _.invert(Codes.TableOpMode);

Codes.LagMode = {
  LAG_REQ: 1,
  LAG_RES: 2,
};

Codes.AliveMode = {
  ALV_NORMAL: 1,
  ALV_SLEEP: 2,
  ALV_WAKEUP: 3,
  ALV_BOT: 4,
};

Codes.ServiceTypes = {
  EMAIL: 1,
  R_TIMO: 2,
  R_WAIT: 3,
  PM_WAIT: 4,
  AVATAR: 5,
  ALERT: 6,
  AVATAR_ING: 7,
};

export default Codes;
